import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.2401 25.0932C19.4934 25.0932 19.7467 24.9999 19.9467 24.7999L28.0401 16.7066C28.4267 16.3199 28.4267 15.6799 28.0401 15.2932L19.9467 7.19991C19.5601 6.81325 18.9201 6.81325 18.5334 7.19991C18.1467 7.58658 18.1467 8.22658 18.5334 8.61325L25.9201 15.9999L18.5334 23.3866C18.1467 23.7732 18.1467 24.4132 18.5334 24.7999C18.7201 24.9999 18.9867 25.0932 19.2401 25.0932Z",
  fill: "#292E36"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.66669 17H27.1067C27.6534 17 28.1067 16.5467 28.1067 16C28.1067 15.4533 27.6534 15 27.1067 15H4.66669C4.12 15 3.66669 15.4533 3.66669 16C3.66669 16.5467 4.12 17 4.66669 17Z",
  fill: "#292E36"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowRightIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
}

})